class SidebarIcon extends HTMLElement{
    constructor(){
      super();
      this.parent = this.closest('li.t4s-cat-item');
      this.id_content = this.getAttribute('aria-controls');
      this.svg = this.querySelector('svg');
      this.control = this.parent.querySelector(`#${this.id_content}`);
      this.addEventListener('click', () => {
        this.Open ? this.closeContent() : this.openContent();
      })
    }
    get Open(){
      return this.hasAttribute('open')
    }
    static observedAttributes = ["open"]
    openContent(){
      
      this.control.style.setProperty('display', "block");
      this.svg.classList.add('rotated');
      this.setAttribute('open', '');
    }
    closeContent(){
      this.control.style.setProperty('display', "none");
      this.svg.classList.remove('rotated');
      this.removeAttribute('open');
    }
  }
  customElements.define('sidebar-icon', SidebarIcon);

/*  filtro */

function setupFacetToggles() {
  const bloques = [
    { selector: ".is--blockididioma", contentSelector: ".t4s-facet-content" },
    { selector: ".is--blockid_price", contentSelector: ".t4s-price_slider_wrapper" },
    { selector: ".t4s-widget-category", contentSelector: "ul.t4s-product-categories" },
    { selector: ".t4s-widget-vendors", contentSelector: "ul.t4s-product-vendors" }
  ];

  bloques.forEach(({ selector, contentSelector }) => {
    document.querySelectorAll(selector).forEach(bloque => {
      const titulo = bloque.querySelector(".t4s-facet-title, .t4s-widget-title");
      const contenido = bloque.querySelector(contentSelector);

      if (titulo && contenido && !bloque.dataset.toggleSet) {
        contenido.style.display = "none";
        titulo.style.cursor = "pointer";

        titulo.addEventListener("click", () => {
          const visible = contenido.style.display === "block";
          contenido.style.display = visible ? "none" : "block";
          titulo.classList.toggle("toggle-active", !visible);
        });

        bloque.dataset.toggleSet = "true";
      }
    });
  });
}

const observer = new MutationObserver(() => {
  setupFacetToggles();
});

document.addEventListener("DOMContentLoaded", () => {
  observer.observe(document.body, { childList: true, subtree: true });
  setupFacetToggles();
});


